export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
